export const TIME_SLOTS = [
  { n: 1, start: "08:10", end: "09:00", label: "8.10 - 9.00" },
  { n: 2, start: "09:00", end: "10:00", label: "9.00 - 10.00" },
  { n: 3, start: "10:00", end: "11:00", label: "10.00 - 11.00" },
  { n: 4, start: "11:00", end: "12:00", label: "11.00 - 12.00" },
  { n: 5, start: "12:00", end: "12:50", label: "12.00 - 12.50" },
  { n: 6, start: "12:50", end: "13:40", label: "12.50 - 13.40" },
  { n: 7, start: "13:40", end: "14:00", label: "13.40 - 14.00" },
];

export const slotLabel = (n) => TIME_SLOTS.find((s) => s.n === n)?.label || `${n}ª ora`;

export function todayStr() {
  const d = new Date();
  const off = d.getTimezoneOffset();
  const local = new Date(d.getTime() - off * 60000);
  return local.toISOString().slice(0, 10);
}

export function formatDateIt(dateStr) {
  if (!dateStr) return "";
  const [y, m, d] = dateStr.split("-");
  return `${d}/${m}/${y}`;
}

export function formatDateTimeIt(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
}
